// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".count-1[data-v-67c568f8] {\n  height: 1.6rem;\n  display: flex;\n}\n.count-1 .worker-num[data-v-67c568f8] {\n  width: 50%;\n}\n.count-1 .worker-num .yq-icon-count[data-v-67c568f8] {\n  font-size: 0.48rem;\n}\n.count-1 .worker-num[data-v-67c568f8]:nth-child(2) {\n  text-align: right;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
